import React from "react";
import Signup from "../../pages/Homepage/Signup/Signup";

export default function LoginRoutes() {
  return <Signup />;
}
